import { getApi } from "./api_instance";

export const getAllCategories = async (dispatch) => {
  try {
    const { data } = await getApi({
      apiUrl: "/projects/api/categories",
    });
    return data;
  } catch (error) {
    throw error;
  }
};
